import { change, stopSubmit, submit } from 'redux-form';
import { CHECKOUT_FORM_NAME } from '../../constants';
import { getAndSetBraintreeToken as getAndSetBraintreeTokenAction } from '../../actions/order/common';
import { gettext } from '@eventbrite/i18n';

export const onPaypalAuthorize =
    (dispatch) =>
    ({ nonce, email, credit }) => {
        dispatch(
            change(CHECKOUT_FORM_NAME, 'payment.paypalBraintreeNonce', nonce),
        );
        dispatch(change(CHECKOUT_FORM_NAME, 'payment.paypalEmail', email));
        dispatch(
            change(
                CHECKOUT_FORM_NAME,
                'payment.isPaypalCreditSelected',
                credit,
            ),
        );
        return dispatch(submit(CHECKOUT_FORM_NAME));
    };

export const onPaypalPaymentMethodSelected = (dispatch) => () => {
    return dispatch(getAndSetBraintreeTokenAction());
};

export const onPaypalError = (dispatch) => (error) => {
    const LOCALIZED_ERROR_MESSAGE_BY_RAW_ERROR_MESSAGE = {
        'Can not open popup window - blocked': gettext(
            'PayPal popup could not be opened. Please, enable popups to pay with PayPal.',
        ),
    };
    const DEFAULT_LOCALIZED_ERROR_MESSAGE = gettext(
        'There was an error connecting to PayPal.',
    );

    const rawErrorMessage = (error && error.message) || '';

    const localizedErrorMessage =
        LOCALIZED_ERROR_MESSAGE_BY_RAW_ERROR_MESSAGE[rawErrorMessage] ||
        DEFAULT_LOCALIZED_ERROR_MESSAGE;

    dispatch(
        stopSubmit(CHECKOUT_FORM_NAME, {
            _error: localizedErrorMessage,
        }),
    );
};
